// extracted by mini-css-extract-plugin
export default {"root":"StopEdit_root__Sz9D9","field":"StopEdit_field__Mu7Ul","fieldLabel":"StopEdit_fieldLabel__WuauW"};